import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
// eslint-disable-next-line jira/import/no-restricted-import
import { getBusinessProjectResources } from '@jira/router-resources__business-common/src/getBusinessProjectResources.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import {
	projectContextResource,
	projectContextResourceWithCache,
} from '@jira/router-resources__project-context/src/projectContextResource.tsx';
import { getServiceDeskSharedNavigationSingleResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { incidentExperimentTraitResource } from '@jira/router-resources__software-incidents/src/incidentExperimentTraitResource.tsx';
import { genericProjectLayout } from '@jira/platform__layouts-generic-project-layout/src/index.tsx';
import { GENERIC_PROJECT_HORIZONTAL_NAV } from '@jira/navigation-apps__horizontal-nav-selector/src/constants.tsx';
import { forgeProjectModuleResource } from '@jira/navigation-apps__resources/src/controllers/forge/index.tsx';
import { staticProjectSidebarConnectAddonsNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar-connect-addons/index.tsx';
import { staticProjectSidebarNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { forgeProjectRoute } from '@jira/router-routes__forge-routes/src/forgeProjectRoute.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { forgeProjectPageEntrypoint } from './ui/project/index.tsx';

export const forgeProjectRouteEntry: Route = createEntry(forgeProjectRoute, () => ({
	layout: genericProjectLayout,

	navigation: {
		menuId: MenuIdProjects,
		horizontal: GENERIC_PROJECT_HORIZONTAL_NAV,
	},

	resources: [
		...getBusinessProjectResources(),
		...getServiceDeskSharedNavigationSingleResources(),
		...getNavigationResources(),
		// these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
		// A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
		incidentExperimentTraitResource,
		projectContextResource,
		forgeProjectModuleResource,
		staticProjectSidebarNavigationResource,
		staticProjectSidebarConnectAddonsNavigationResource,
		// end of resources expanded from getNavigationSidebarProjectResource
		forgeProjectModuleResource,
		projectContextResourceWithCache,
		getConsolidationStateResource(),
	],

	entryPoint: () => forgeProjectPageEntrypoint,
	supportsPreviewPanel: true,

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
